<template>
    <v-card class="pa-3 ma-md-3">
        <template v-if="!showFilters">
            <v-toolbar flat color="#1d2735" dark>
                <v-icon class="white--text" style="font-size: 45px"
                    >mdi-account-supervisor-circle</v-icon
                >
                <pre><v-toolbar-title><h2>Lista de notas</h2></v-toolbar-title></pre>
            </v-toolbar>
            <v-tooltip right>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn
                        fab
                        :to="{ path: `/guardar-nota-proveedor` }"
                        :loading="isloading"
                        :disabled="isloading"
                        color="success"
                        class="mt-2"
                        v-bind="attrs"
                        v-on="on"
                    >
                        <v-icon class="white--text">mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span>Nueva nota</span>
            </v-tooltip>
            <v-row>
                <v-col cols="12" md="4">
                    <proveedoresSelectVue
                        label="Proveedor"
                        v-model="id_proveedor"
                        item-text="nombre"
                        item-value="id"
                    ></proveedoresSelectVue>
                </v-col>
                <v-col cols="12" md="4">
                    <v-select
                        v-model="albaran_id"
                        :items="albaranes"
                        chips
                        multiple
                        label="Albaranes"
                        item-text="nro"
                        item-value="id"
                        dense
                    >
                    </v-select>
                </v-col>
                <v-col cols="12" md="4">
                    <v-btn
                        color="red"
                        style="color: white"
                        class="mr-2"
                        @click="
                            () => {
                                id_proveedor = null;
                                albaran_id = null;
                                getNotas();
                            }
                        "
                        >Limpiar</v-btn
                    >
                    <v-btn color="success" @click="ExportExcel">
                        <v-icon class="white--text">mdi-file-excel</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" md="4">
                    <v-text-field
                        prepend-icon="mdi-account-search"
                        v-model="search"
                        label="Buscar"
                    ></v-text-field>
                </v-col>
            </v-row>
        </template>
        <v-data-table
            dense
            :headers="headers"
            :items="Notas"
            :search="search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            @update:sort-by="
                (val) => {
                    sortby = val;
                }
            "
            @update:sort-desc="
                (val) => {
                    sortdesc = val;
                }
            "
            @click:row="
                (item) => {
                    OpenOrdenInNextWindow(item);
                }
            "
            :server-items-length="total_notas"
            @update:items-per-page="ChangeSize"
            @pagination="ChangePage"
        >
            <!-- proveedor -->
            <template v-slot:item.proveedor="{ item }">
                <span>
                    {{ item.albaranes[0]?.proveedor?.nombre }}
                </span>
            </template>
            <!-- referencia -->
            <template v-slot:item.referencia="{ item }">
                <v-chip
                    size="small"
                    v-for="albaran in item.albaranes"
                    :key="albaran.id"
                    >{{ albaran.nro }}</v-chip
                >
            </template>

            <template v-slot:item.total="{ item }">
                <span v-if="item.total != null">{{
                    formatPrice(item.total)
                }}</span>
            </template>
            <template v-slot:item.pdf="{ item }">
                <a :href="`api/pdf-pedido-proveedor/${item.id}`">
                    <v-icon
                        small
                        class="mr-2"
                        color="red"
                        style="font-size: 25px"
                        title="PDF"
                        >mdi-pdf-box</v-icon
                    >
                </a>
            </template>

            <template v-slot:item.pdt_albaran="{ item }">
                <v-chip
                    :color="
                        item.pdt_albaran == 0 || item.pdt_albaran == null
                            ? ''
                            : 'green'
                    "
                    size="small"
                >
                    {{
                        item.pdt_albaran == 0 || item.pdt_albaran == null
                            ? "Pendiente"
                            : "Creado"
                    }}
                </v-chip>
            </template>

            <template v-slot:item.action="{ item }">
                <a @click.stop="openModal(item)">
                    <v-icon
                        small
                        class="mr-2"
                        color="red"
                        style="pointer-events: none; font-size: 25px"
                        title="BORRAR"
                        >mdi-trash-can</v-icon
                    >
                </a>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteNota()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import { debounce } from "../../../helpers";

import ConfimDialog from "../../albaranes/componentes/ConfimDialog.vue";
import proveedoresSelectVue from "../../../components/general/proveedoresSelect.vue";
import { formatPrice } from "../../../helpers";

export default {
    props: ["showFilters"],

    components: { proveedoresSelectVue, ConfimDialog },
    watch: {
        sortby(val) {
            console.log(val);
            this.getNotas();
        },
        sortdesc: debounce(function (val) {
            console.log(val);
            this.getNotas();
        }, 500),
        id_proveedor: debounce(function (val) {
            this.getNotas();
        }, 500),
        albaran_id: debounce(function (val) {
            this.getNotas();
        }, 500),
        search: debounce(function (val) {
            this.getNotas();
        }, 500),
    },
    data() {
        return {
            total_notas: 0,
            sortdesc: null,
            sortby: null,
            pedido: null,
            confirm_albaran: false,
            proveedores: [],
            id_proveedor: null,
            albaran_id: null,
            albaranes: [],
            search: "",
            headers: [
                { text: "Nota", value: "id", sortable: true },
                {
                    text: "Proveedor",
                    value: "proveedor",
                    sortable: true,
                },
                // {
                //     text: "FECHA PEDIDO",
                //     value: "fecha_pedido",
                //     sortable: true,
                // },
                {
                    text: "Referencia",
                    value: "referencia",
                    sortable: true,
                },
                // {
                //     text: "F. PREV SERVICIO",
                //     value: "fecha_prevista",
                //     sortable: true,
                // },
                // { text: "DESCRIPCION", value: "descripcion" },
                // {
                //     text: "FECHA REAL RECEPCION",
                //     value: "fecha_real",
                //     sortable: true,
                // },
                // { text: "ESTADO", value: "estado", sortable: false },
                // { text: "ALBARAN", value: "pdt_albaran", sortable: true },
                { text: "Costo", value: "total", sortable: false },
                // { text: "Pdf", value: "pdf" },
                { text: "Acciones", value: "action", sortable: false },
            ],
            Notas: [],
            selectedItem: 0,
            dialog: false,
            recepcionar: false,
            cantidad: 15,
            pendiente_albaran: 0,
            page: 1,
        };
    },
    created() {
        if (this.albaran_id_ext) {
            this.albaran_id = this.albaran_id_ext;

            this.getNotas();
        }
        this.getNotas();
        this.getAlbaranes();
    },
    methods: {
        OpenOrdenInNextWindow(item) {
            //this.$router.push(`/guardar-pedido-proveedor?id=${item.id}`);
            window.open(`/#/guardar-nota-proveedor?id=${item.id}`, "_blank");
        },
        openModalAlbaran(item) {
            this.confirm_albaran = true;
            this.pedido = item;
        },
        // saveAlbaran() {
        //     let lineas = [];
        //     this.pedido.lineas.forEach((linea) => {
        //         lineas.push({
        //             id_pedido: this.pedido.id,
        //             id_pedido_linea: linea.id,
        //             id_iva: linea?.producto?.id_iva,
        //             cantidad: linea.cantidad,
        //             dcto: linea.dcto,
        //             descripcion: linea.descripcion,
        //             id_producto_compra: linea.id_producto_compra,
        //             precio: linea.precio,
        //             total: linea.precio * linea.cantidad - linea.dcto,
        //         });
        //     });
        //     let albaran = {
        //         id_proveedor: this.pedido.id_proveedor,
        //         importe: this.pedido.total,
        //         observaciones: this.pedido.observaciones,
        //         lineas: lineas,
        //         id_pedido: this.pedido.id,
        //     };
        //     axios
        //         .post("api/save-albaran", albaran)
        //         .then((res) => {
        //             this.$router.push("lista-albaranes");
        //         })
        //         .catch((error) => {
        //             //console.log(error.response.status);
        //             if (error.response.code == 400) {
        //                 this.$custom_error(error.response.data.error);
        //             } else {
        //                 this.$custom_error("Algo salio mal");
        //             }
        //         });
        // },
        ChangeSize(event) {
            this.cantidad = event;
            this.getNotas();
        },
        ChangePage(event) {
            this.page = event.page;
            this.getNotas();
        },
        getNotas() {
            axios
                .get(
                    `api/notas?page=${this.page}&amount=${this.cantidad}&id=0${
                        this.id_proveedor != null
                            ? `&id_proveedor=${this.id_proveedor}`
                            : ""
                    }${
                        this.albaran_id != null
                            ? `&albaran_id=${this.albaran_id}`
                            : ""
                    }${this.search != null ? `&search=${this.search}` : ""}
                    ${this.sortby != null ? `&sortby=${this.sortby}` : ""}
                    ${this.sortdesc != null ? `&sortdesc=${this.sortdesc}` : ""}
                    `
                )
                .then(
                    (res) => {
                        console.log("get notas", res);
                        this.Notas = res.data.success.data;
                        this.total_notas = res.data.success.total;
                    },
                    (err) => {
                        this.$custom_error("Error consultando las notas");
                    }
                );
        },
        getAlbaranes() {
            axios
                .get(
                    `api/get-albaranes?page=${this.page}&amount=${this.cantidad}`
                )
                .then(
                    (res) => {
                        this.albaranes = res.data.success.data;
                    },
                    (err) => {
                        this.$custom_error("Error consultando los albaranes");
                    }
                );
        },
        openModal(item) {
            this.selectedItem = this.Notas.indexOf(item);
            this.dialog = true;
        },
        deleteNota() {
            axios.delete(`api/nota/${this.Notas[this.selectedItem].id}`).then(
                (res) => {
                    this.$toast.sucs("Nota eliminada con éxito");
                    this.dialog = false;
                    this.getNotas();
                },
                (err) => {
                    this.$custom_error("Error eliminando la nota");
                }
            );
        },
        reclamar(item) {
            this.selectedItem = this.Notas.indexOf(item);

            axios
                .get(
                    `api/reclamar-pedido-proveedor/${
                        this.Notas[this.selectedItem].id
                    }`
                )
                .then(
                    (res) => {
                        this.$toast.sucs(res.data.success);
                        // this.recepcionar = false;
                        this.getNotas();
                    },
                    (err) => {
                        this.$custom_error(res.data.error);
                    }
                );
        },

        ExportExcel() {
            axios
                .get(`/api/excel-proveedor-pedido`, { responseType: "blob" })
                .then((response) => {
                    console.log("res", response);
                    const downloadUrl = window.URL.createObjectURL(
                        new Blob([response.data])
                    );
                    const link = document.createElement("a");
                    link.href = downloadUrl;
                    link.setAttribute("download", "proveedor_pedido.xlsx");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch((error) => {
                    console.error("Error exporting clientes:", error);
                });
        },
        formatPrice,
    },
    computed: {
        isloading: function () {
            // return this.$store.getters.getloading
        },
    },
};
</script>
